'use client';

import { useRef } from 'react';
import { useStore } from '@/store/store';
import {
    getInfluencerVideoSelectedProps,
    getInfluencerVideoZoneTrackingData
} from '@/tracking/amplitude/events/general/influencer-video';

type UseInfluencerVideoSelectedParams = {
    module: 'video_tile_zone' | 'video_preview_carousel';
    position: number;
    videoTitle: string;
    pageName: 'home' | 'influencer_hub';
};

export const useInfluencerVideoSelected = <T extends HTMLElement>({
    module,
    position,
    videoTitle,
    pageName
}: UseInfluencerVideoSelectedParams) => {
    const containerRef = useRef<T>(null);
    const { sendEvent } = useStore((state) => state.tracking);
    const handleShowLoading = useStore((state) => state.loading.handleShowLoading);

    const handleVideoSelected = () => {
        const { zoneName, zonePosition } = getInfluencerVideoZoneTrackingData(
            containerRef as React.RefObject<HTMLElement>
        );
        const eventProps = getInfluencerVideoSelectedProps({
            module,
            position,
            videoTitle,
            zoneName,
            zonePosition,
            pageName
        });
        sendEvent([{ destination: 'amplitude', eventProps }]);
        handleShowLoading();
    };

    return { containerRef, handleVideoSelected };
};
